export default class OptimizelyHelper {
  constructor() {
    this.setActiveExperiments();
    this.setVariations();
  }

  sendActiveExperimentsToAdobe() {
    _satellite.setVar('opt-exp-ids', this.activeExperiments.join('|'));
  }

  sendVariationsToAdobe() {
    _satellite.setVar('opt-variation-ids', this.variationIds.join('|'));
  }

  setActiveExperiments() {
    this.activeExperiments = window.optimizely.get('state').getActiveExperimentIds();
  }

  setVariations() {
    // object of all optimizely variations, key = expId, value = object containing shown variation's id
    const variations = optimizely.get('state').getVariationMap();
    this.variationIds = this.activeExperiments.map(expId => (variations[expId] || {}).id);
  }
}
